import { images } from "../../config/images";
import { siteContent } from "../../content/siteContent";
import { ResponsiveImage } from "./ResponsiveImage";

export function FeatureImage() {
  const { featureImage } = siteContent;

  return (
    <section className="home-feature" aria-label="La experiencia Evolution">
      <div className="home-shell">
        <figure className="home-feature__figure">
          <ResponsiveImage
            image={images.feature}
            className="home-feature__image"
            sizes="(min-width: 1440px) 1360px, 94vw"
          />
          <figcaption className="home-feature__caption">
            <p className="home-eyebrow">{featureImage.eyebrow}</p>
            <p>{featureImage.caption}</p>
            <span>{featureImage.imageNote}</span>
          </figcaption>
        </figure>
      </div>
    </section>
  );
}
